import React from "react";
import SectorLayout from "@/components/SectorLayout";
import data from "@/data/sectors/artisanat";
export default function SecteurArtisanat() { return <SectorLayout data={data} />; }
